import GalleryViewSction from "./GalleryViewSction";
// import { formatDateDetails } from "../exports/functions";
const GallerySection = (props) => {
  const { galleryHeaderData, galleryImagesData } = props;
  return (
    <section className="gallery py-50">
      <div className="container">
        <div className="container">
          <div className="section-heading text-center" id="galleryheader">
            <div className="flex-align d-inline-flex gap-8 mb-16">
              <span className="text-main-600 text-2xl d-flex">
                <i className="ph-bold ph-book-open" />
              </span>
              <h5 className="text-main-600 mb-0">
                {galleryHeaderData[0]?.snippet}
              </h5>
            </div>
            <h2 className="mb-24">{galleryHeaderData[0]?.title}</h2>
            <p className="">{galleryHeaderData[0]?.description}</p>
          </div>
          {/* <div className="text-center">
            <div
              className="nav-tab-wrapper bg-white border border-neutral-40 p-16 mb-40 d-inline-block"
              data-aos="zoom-out"
            >
              <ul
                className="nav nav-pills common-tab edit gap-16"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 active"
                    id="pills-education-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-education"
                    type="button"
                    role="tab"
                    aria-controls="pills-education"
                    aria-selected="true"
                  >
                    <i className="text-xl d-flex text-main-600 ph-bold ph-squares-four" />
                    Online Education
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                    id="pills-University-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-University"
                    type="button"
                    role="tab"
                    aria-controls="pills-University"
                    aria-selected="false"
                  >
                    <i className="text-xl d-flex text-main-600 ph-bold ph-magic-wand" />
                    University
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                    id="pills-Tutors-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Tutors"
                    type="button"
                    role="tab"
                    aria-controls="pills-Tutors"
                    aria-selected="false"
                  >
                    <i className="text-xl d-flex text-main-600 ph-bold ph-code" />
                    Tutors
                  </button>
                </li>
              </ul>
            </div>
          </div> */}
          {/* <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-education"
              role="tabpanel"
              aria-labelledby="pills-education-tab"
              tabIndex={0}
            >
              <div className="masonry">
                {galleryImagesData?.map((image, index) => {
                  // const formatedDate = formatDateDetails(image?.date || "");
                  return (
                    <Link
                      key={image.id}
                      to="/gallery/gallery-view"
                      state={{
                        id: image.id,
                      }}
                    >
                      <div
                        className="masonry__item position-relative rounded-12 overflow-hidden"
                        id={`gallery${image.id}`}
                      >
                        <span
                          className="image-count position-absolute top-0 start-0 bg-main-two-600 text-white px-2 py-1"
                          style={{ fontSize: "12px", zIndex: 1 }}
                        >
                          {image?.images?.length} Images
                        </span>
                        <ul
                          className="custom-social-list flex-center gap-12 d-flex position-absolute start-50 top-50 w-100 h-100 translate-middle"
                          style={{ flexDirection: "column" }}
                        >
                          <li className="custom-social-list__item">
                            <h2
                              className="mb-24"
                              style={{ textAlign: "center", color: "#ffffff" }}
                            >
                              {image?.name}
                            </h2>
                          </li>
                        </ul>
                        <img
                          alt="img2"
                          src={
                            image?.thumbnail[0]?.media?.url &&
                            `${process.env.REACT_APP_cmsUrl}${image?.thumbnail[0]?.media?.url}`
                          }
                        />
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>*/}

          <GalleryViewSction galleryImagesData={galleryImagesData} />
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
